<template>
  <div id="inputErrorMessage">
    <div id="errorAlert" class="rounded card-body bg-danger text-white mx-3 mt-4 mb-0">
      <div class="d-flex">
        <div class="col-2">
          <i class="fas fa-exclamation-triangle mr-2 fa-2x"></i>
        </div>
        <div class="col-10">
          <h5>{{errorMsgHeader}}</h5>
          <!-- <h5>Oops! Please correct the following input {{errorWord}}:</h5> -->
          <ul class="m-0 pl-3">
            <li v-for="(error,index) in errors" :key="index">{{error}}</li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["errorMsgHeader","errors"]
};
</script>